'use client';

import React from 'react';
import styled from 'styled-components';

const OuterWrapper = styled.div<{
  $headerHeight: number;
  $footerHeight: number;
}>`
  display: flex;
  height: calc(
    100vh - ${(props) => props.$headerHeight}px -
      ${(props) => props.$footerHeight}px
  );
  align-items: center;
  justify-content: center;
  width: 100vw;
`;

const ContentArea = styled.div`
  display: inline-block;
`;

export const CenteredContent = ({
  children,
  headerHeight = 0,
  footerHeight = 0,
  ...rest
}: {
  children: React.ReactNode;
  headerHeight?: number;
  footerHeight?: number;
  rest?: React.HTMLAttributes<HTMLDivElement>;
}) => {
  return (
    <OuterWrapper
      $headerHeight={headerHeight}
      $footerHeight={footerHeight}
      {...rest}
    >
      <ContentArea>{children}</ContentArea>
    </OuterWrapper>
  );
};

export const ImageWrapper = styled.div`
  & > img {
    width: 768px;
    height: auto;
    max-width: 90vw;
  }
`;

export const InnerWrapper = styled.div`
  &&& > * {
    text-align: center;
    margin-bottom: 1.5rem;
  }
`;
